$(document).ready(function(){
    jQuery('[data-social-slider-arrow="prev"]').addClass('slick-arrow--active');
    jQuery('[data-social-slider-arrow="next"]').addClass('slick-arrow--active');
    
    $('[data-social-slider]').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        nextArrow: jQuery('[data-social-slider-arrow="next"'),
        prevArrow: jQuery('[data-social-slider-arrow="prev"'),
        infinite: true,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });
});


// WEBPACK FOOTER //
// ./social-slider.js